import { Message, Button } from 'semantic-ui-react';

export const ConfirmationPopup = ({
  show,
  error = false,
  content = '',
  showConfirm = false,
  failedFields = [],
  onConfirm,
  onCancel,
  onClose
}) => {
  if (!show) return null;
  
  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <Message
          positive={!error && !!content}
          negative={!!error}
          style={{ marginBottom: 20, width: '100%' }}
        >
          {showConfirm && failedFields.length > 0 ? (
            <div style={{ textAlign: 'left' }}>
              <div>The following fields are marked as Failed:</div>
              <ul style={{ marginTop: 8, marginBottom: 8 }}>
                {failedFields.map((f, idx) => (
                  <li key={idx}>{f.name}</li>
                ))}
              </ul>
              <div style={{ marginTop: 12 }}>Do you want to submit anyway?</div>
            </div>
          ) : (
            content
          )}
        </Message>
        {showConfirm ? (
          <div style={{ display: 'flex', gap: 10 }}>
            <Button size='large' color='green' onClick={onConfirm}>
              Confirm
            </Button>
            <Button size='large' color='grey' onClick={onCancel}>
              Cancel
            </Button>
          </div>
        ) : (
          <Button size='large' color='grey' onClick={onClose}>
            OK
          </Button>
        )}
      </div>
    </div>
  );
};